(function () {
    'use strict';

    function freeFormTextQuestionConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/freeFormTextQuestionConfiguration.html',
            link: function (scope) {

            }
        };
    }

    freeFormTextQuestionConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('freeFormTextQuestionConfiguration', freeFormTextQuestionConfiguration);
})();
